import {
  AppointmentsHover,
  DashboardHover,
  DoctorHover,
  PatientHover,
  SettingsHover,
  AdminPanelHover,
} from "../icons/HoverIcons";
import {
  Dashboard,
  Schedule,
  Doctor,
  Patient,
  Appointments,
  AdminPanel,
  Help,
  Settings,
} from "../icons/Icons";
import { BiParty } from "react-icons/bi";

import { MdOutlineContactSupport, MdOutlineNewReleases } from "react-icons/md";

export const mainItems = [
  {
    name: "Dashboard",
    icon: <Dashboard style={"md:w-5 lg:w-6"} />,
    hoverIcon: <DashboardHover style={"md:w-5 lg:w-6"} />,
  },
  {
    name: "Doctors",
    icon: <Doctor style={"md:w-5 lg:w-6"} />,
    hoverIcon: <DoctorHover style={"md:w-5 lg:w-6"} />,
  },
  {
    name: "Appointments",
    icon: <Appointments style={"md:w-5 lg:w-6"} />,
    hoverIcon: <AppointmentsHover style={"md:w-5 lg:w-6"} />,
  },
  {
    name: "Patients",
    icon: <Patient style={"md:w-5 lg:w-6"} />,
    hoverIcon: <PatientHover style={"md:w-5 lg:w-6"} />,
  },
  {
    name: "What's New",
    icon: <BiParty className="w-6 h-6 md:w-6 md:h-6" />,
    hoverIcon: <BiParty className="w-6 h-6 md:w-6 md:h-6" />,
  },
];

export const supportItems = [
  // {
  //   name: "Help Center",
  //   icon: <Help />,
  //   hoverIcon: <HelpHover />,
  // },
  {
    name: "Settings",
    icon: <Settings style={"md:w-5 lg:w-6"} />,
    hoverIcon: <SettingsHover style={"md:w-5 lg:w-6"} />,
  },
  {
    name: "Support",
    icon: <MdOutlineContactSupport className="w-6 h-6" />,
    hoverIcon: <MdOutlineContactSupport className="w-6 h-6" />,
  },
];
